import { render, staticRenderFns } from "./PaginationFront.vue?vue&type=template&id=806a1d42"
import script from "./PaginationFront.vue?vue&type=script&setup=true&lang=js"
export * from "./PaginationFront.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports